import React, { useState } from 'react';
import { LayoutDashboard, MessageSquare, TrendingUp, Settings, Eye, MousePointer, Phone, Plus } from 'lucide-react';
import { DashboardLayout } from '../components/DashboardLayout';
import { Link, useNavigate } from 'react-router-dom';
import { PromoteListingModal } from '../components/modals/PromoteListingModal';
import { MessageModal } from '../components/modals/MessageModal';
export function SellerDashboardPage() {
  const navigate = useNavigate();
  const [isPromoteModalOpen, setIsPromoteModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [selectedListingId, setSelectedListingId] = useState<number | null>(null);
  const handleProceedToPay = () => {
    // Close promote modal and show payment confirmation
    setIsPromoteModalOpen(false);
    setIsMessageModalOpen(true);
  };
  const handleEdit = (listingId: number) => {
    navigate(`/create-listing?edit=${listingId}`);
  };
  const handleViewInquiries = (listingId: number) => {
    navigate('/seller/inquiries');
  };
  const navItems = [{
    label: 'Overview',
    icon: LayoutDashboard,
    path: '/dashboard/seller'
  }, {
    label: 'Inquiries',
    icon: MessageSquare,
    path: '/seller/inquiries',
    badge: '12'
  }, {
    label: 'Performance',
    icon: TrendingUp,
    path: '/seller/performance'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/seller/settings'
  }];
  return <DashboardLayout title="Seller Console" personaLabel="SELLER" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="RK" data-id="element-5688">
      <div className="flex justify-between items-center mb-8" data-id="element-5689">
        <div data-id="element-5690">
          <h1 className="text-2xl font-bold mb-1" data-id="element-5691">My Listings</h1>
          <p className="text-gray-500 font-mono text-sm" data-id="element-5692">
            Managing 2 active plot listings.
          </p>
        </div>
        <Link to="/create-listing" className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5693">
          <Plus className="w-4 h-4" data-id="element-5694" /> Post New Plot
        </Link>
      </div>

      {/* Performance Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-5695">
        <div className="bg-white border border-gray-300 p-6" data-id="element-5696">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2 flex items-center gap-2" data-id="element-5697">
            <Eye className="w-4 h-4" data-id="element-5698" /> Total Views (30d)
          </h3>
          <div className="text-3xl font-bold" data-id="element-5699">1,248</div>
          <div className="text-xs text-green-600 font-bold mt-1" data-id="element-5700">
            +12% vs last month
          </div>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-5701">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2 flex items-center gap-2" data-id="element-5702">
            <MousePointer className="w-4 h-4" data-id="element-5703" /> Click Rate
          </h3>
          <div className="text-3xl font-bold" data-id="element-5704">4.8%</div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-5705">Avg. industry: 3.2%</div>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-5706">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2 flex items-center gap-2" data-id="element-5707">
            <Phone className="w-4 h-4" data-id="element-5708" /> Leads Generated
          </h3>
          <div className="text-3xl font-bold" data-id="element-5709">18</div>
          <div className="text-xs text-green-600 font-bold mt-1" data-id="element-5710">
            3 new today
          </div>
        </div>
      </div>

      {/* Active Listings Table */}
      <div className="bg-white border border-gray-300 mb-8" data-id="element-5711">
        <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-5712">
          <h2 className="font-bold text-lg" data-id="element-5713">Active Listings</h2>
        </div>
        <div className="overflow-x-auto" data-id="element-5714">
          <table className="w-full text-left text-sm" data-id="element-5715">
            <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-5716">
              <tr data-id="element-5717">
                <th className="p-4 font-bold" data-id="element-5718">Property</th>
                <th className="p-4 font-bold" data-id="element-5719">Price</th>
                <th className="p-4 font-bold" data-id="element-5720">Status</th>
                <th className="p-4 font-bold" data-id="element-5721">Views</th>
                <th className="p-4 font-bold" data-id="element-5722">Inquiries</th>
                <th className="p-4 font-bold text-right" data-id="element-5723">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-5724">
              {[{
              id: 1,
              title: 'Corner Plot in Hinjewadi',
              price: '₹45 L',
              status: 'Active',
              views: 842,
              inquiries: 12
            }, {
              id: 2,
              title: 'Agri Land in Mulshi',
              price: '₹22 L',
              status: 'Pending',
              views: 406,
              inquiries: 6
            }].map((item, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-5725">
                  <td className="p-4 font-bold" data-id="element-5726">
                    <Link to={`/listing/${item.id}`} className="hover:underline hover:text-blue-600" data-id="element-5727">
                      {item.title}
                    </Link>
                  </td>
                  <td className="p-4 font-mono" data-id="element-5728">{item.price}</td>
                  <td className="p-4" data-id="element-5729">
                    <span className={`inline-block px-2 py-0.5 text-xs font-bold rounded-sm border ${item.status === 'Active' ? 'bg-green-100 text-green-800 border-green-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200'}`} data-id="element-5730">
                      {item.status.toUpperCase()}
                    </span>
                  </td>
                  <td className="p-4" data-id="element-5731">{item.views}</td>
                  <td className="p-4" data-id="element-5732">
                    <button onClick={() => handleViewInquiries(item.id)} className="font-bold text-blue-600 hover:underline" data-id="element-5733">
                      {item.inquiries}
                    </button>
                  </td>
                  <td className="p-4 text-right" data-id="element-5734">
                    <div className="flex justify-end gap-2" data-id="element-5735">
                      <button onClick={() => handleEdit(item.id)} className="text-xs font-bold border border-gray-300 px-2 py-1 hover:bg-gray-50" data-id="element-5736">
                        Edit
                      </button>
                      <button onClick={() => {
                    setSelectedListingId(item.id);
                    setIsPromoteModalOpen(true);
                  }} className="text-xs font-bold bg-blue-50 text-blue-700 border border-blue-200 px-2 py-1 hover:bg-blue-100" data-id="element-5737">
                        Promote
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <PromoteListingModal isOpen={isPromoteModalOpen} onClose={() => setIsPromoteModalOpen(false)} onProceedToPay={handleProceedToPay} data-id="element-5738" />

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Payment Processing" message="Redirecting to payment gateway... In production, this would integrate with Razorpay or Stripe for secure payment processing." type="info" data-id="element-5739" />
    </DashboardLayout>;
}